import React from 'react';

import {
	useIsBelowSmallOnly,
	useIsSmallAndAbove,
} from '../hooks/mediaQueries';
import LargeListerLayout from './LargeListerLayout';
import SmallListerLayout from './SmallListerLayout';

const Container = () => {
	const isBelowSmallOnly = useIsBelowSmallOnly();
	const isSmallAndAbove = useIsSmallAndAbove();

	return (
		<>
			{isBelowSmallOnly && <SmallListerLayout />}
			{isSmallAndAbove && <LargeListerLayout />}
		</>
	);
};

export default Container;
